import { ANONYMOUS_WEB_PLAYER_ID_PREFIX } from '../common/ReplicantConstants';

export function isAnonymousWebPlayer(id: string): boolean {
    return id.startsWith(ANONYMOUS_WEB_PLAYER_ID_PREFIX);
}
